import emittable from './emittable'
import {
    Scene,
    PerspectiveCamera,
    Color,
    Fog,
    Vector3
} from 'three'
import GlobeCloud from './globe-object'

// https://codepen.io/Mamboleoo/pen/JYJPJr

class GlobeSceneCamera extends PerspectiveCamera {
    constructor(){
        super(35, window.innerWidth/window.innerHeight, 0.1, 500);
        //this.position.set(-300,0,750);
        this.position.set(-50,0,200);
    }

    resize(width,height){
        this.aspect = width / height;
    }
}

export default emittable(
    class GlobeScene extends Scene {

        get application(){
            return this._application;
        }

        set application(application){
            this._application = application;
            this.emit('addedToApplication',application);
        }

        set offset(num){
            this.camera.position.z = 200 + num * 50;
            this.globe.rotation.y = Math.PI / 2 * (num / 4);
            this.globe.rotation.x = Math.PI / 2 * (num / 2);
        }

        constructor(){
            super();
            this.background = null;
            this.fog = new Fog(0xffffff,150,260);
            this.camera = new GlobeSceneCamera();
            this.globe = new GlobeCloud();
            this.add(this.globe);
        }

        resize(width,height){
            this.camera.aspect = width / height;
            this.camera.updateProjectionMatrix();
        }

        emit(...args){
            super.emit(...args);
            this.camera && this.camera.emit(...args);
        }
    }
);